import styled from "styled-components";

const Layout = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem 1.5rem;
  transition: all 0.3s ease;
`;

export default Layout;
